import PropTypes from 'prop-types';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Form } from 'antd';
import { CreateUpdateContainer } from '../../../components';
import { useVeterinariansFields } from './fields/veterinariansFields';
import { useCustomSubmit } from './utils/customSubmit';
import { useSocketContext } from '../../../contexts/SocketContext';
import { EditingLocked } from '../../../components/EditingLocked/EditingLocked';
import { editingLocked } from '../../../utils/editingLocked';
import { useAuthContext } from '../../../contexts/AuthContext';

export const CreateUpdateVeterinarian = ({ purpose }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { profileLock } = useSocketContext();
  const { ownerInfo, getUserProfiles } = useAuthContext();
  const { id } = useParams();
  const [form] = Form.useForm();
  const [country, setCountry] = useState('');
  const { veterinarianFields } = useVeterinariansFields({
    form,
    country,
    setCountry
  });

  const { customSubmit } = useCustomSubmit({
    baseUrl: 'veterinarians',
    purpose
  });

  useEffect(() => {
    (async () => {
      await getUserProfiles();
    })();
  }, []);

  return (
    <>
      {editingLocked(profileLock, id) && (
        <EditingLocked
          t={t}
          resources={{
            button: 'veterinarian_groomer',
            text: 'profile'
          }}
          navigate={navigate}
        />
      )}
      <CreateUpdateContainer
        withPageHeaderCustom
        purpose={purpose}
        fields={veterinarianFields}
        fieldsCardTitle={t('veterinarians.header_panel')}
        fieldsCardIcon="medicine"
        resource="veterinarians"
        baseUrl="veterinarians"
        customSubmit={customSubmit}
        customId={ownerInfo?._id}
        disabled={editingLocked(profileLock, id)}
        form={form}
      />
    </>
  );
};

CreateUpdateVeterinarian.propTypes = {
  purpose: PropTypes.string.isRequired
};
